import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "form",
  "lazy-validation": ""
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.modalShow,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalShow) = $event)),
    width: "800",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        (_ctx.scenario && _ctx.model)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { "primary-title": "" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("message.copyChanges")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.copyChangesInformation")), 1),
                    _createVNode(_component_v_select, {
                      class: "mt-4",
                      multiple: "",
                      variant: "outlined",
                      items: _ctx.scenario.changedLocations,
                      modelValue: _ctx.scenario.selectedLocations,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scenario.selectedLocations) = $event)),
                      "item-value": "id",
                      label: _ctx.$t('message.locations')
                    }, {
                      selection: _withCtx(({ item }) => [
                        _createVNode(_component_v_chip, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.raw.name), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      item: _withCtx(({ item, props }) => [
                        _createVNode(_component_v_list_item, _mergeProps(props, {
                          title: item.raw.name
                        }), {
                          prepend: _withCtx(({ isSelected }) => [
                            _createVNode(_component_v_checkbox_btn, {
                              "model-value": isSelected,
                              tabindex: "-1"
                            }, null, 8, ["model-value"])
                          ]),
                          subtitle: _withCtx(() => [
                            (item.raw.changeType == 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t("message.opening")), 1))
                              : _createCommentVNode("", true),
                            (item.raw.changeType == 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("message.closure")), 1))
                              : _createCommentVNode("", true),
                            (item.raw.changeType == 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("message.edited")), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1040, ["title"])
                      ]),
                      _: 1
                    }, 8, ["items", "modelValue", "label"]),
                    _createVNode(_component_v_select, {
                      variant: "outlined",
                      modelValue: _ctx.scenario.destinationScenarioId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scenario.destinationScenarioId) = $event)),
                      items: _ctx.scenariosSorted,
                      "item-title": "name",
                      label: _ctx.$t('message.targetScenario'),
                      "item-value": "id"
                    }, {
                      item: _withCtx(({ item, props }) => [
                        _createVNode(_component_v_list_item, _mergeProps(props, {
                          title: item.raw.name,
                          class: { 'font-weight-bold': item.raw.isTop }
                        }), null, 16, ["title", "class"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "items", "label"]),
                    _createVNode(_component_v_checkbox, {
                      density: "compact",
                      modelValue: _ctx.scenario.deleteSourceScenario,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.scenario.deleteSourceScenario) = $event)),
                      disabled: _ctx.scenario.selectedLocations.length != _ctx.scenario.changedLocations.length,
                      label: _ctx.$t('message.deleteSourceScenario')
                    }, null, 8, ["modelValue", "disabled", "label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      onClick: _ctx.submit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.copyChanges")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      onClick: _ctx.close
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}